import { render, staticRenderFns } from "./DomingosTrabalhados.vue?vue&type=template&id=2d96d36b&"
import script from "./DomingosTrabalhados.vue?vue&type=script&lang=js&"
export * from "./DomingosTrabalhados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports